import type { PortalProfile } from '../auth/types'

// Moduł Kontenery: profile.features.containers z /api/me — backend liczy go jako kill-switch
// app.containers.enabled AND flaga firmy (containers_module_flags). Flaga FIRMOWA: company master jej NIE omija.
// Brak pola (stary backend / deploy skew) = moduł wyłączony; twardą granicą jest i tak 403 z /api/containers/**.
export const hasContainersModuleAccess = (profile: PortalProfile | null | undefined): boolean =>
  profile?.features?.containers === true

/**
 * Profil sesji z wygaszonym modułem Kontenery (403 bramki w trakcie sesji, FE-E1): jedna reguła dla ContainersPage (handler bramki)
 * i paneli modułu poza /containers/* (Ustawienia › Automatyzacje, PR13) — sidebar i karta Ustawień chowają moduł bez F5.
 */
export const withoutContainersModule = (profile: PortalProfile): PortalProfile => ({
  ...profile,
  features: { ...profile.features, containers: false },
})
